import { useNavigate } from "react-router-dom";
import CustomButton from "../../../Components/Buttons/Custom";

export default function TopMessage({ variant, reason, description }) {
  const fn = localStorage.getItem("fn");
  const navigate = useNavigate();
  const variants = {
    kycRejected: {
      text: (
        <>
          <p>
            <span>{fn} عزیز </span>خوش آمدید 👋 احراز هویت شما رد شده است ⛔️
          </p>
          <p>{`علت: ${reason}. ${description}`}</p>
        </>
      ),
      cta: (
        <CustomButton
          text="تکمیل احراز هویت"
          className="px-5 sm:min-w-40 whitespace-nowrap bg-zi-buttonbg-primary text-zi-text-dark hocus:opacity-85"
          textShadow={true}
          onClick={() => navigate("/profile/kyc")}
        />
      ),
    },
    kycApproved: {
      text: (
        <p>
          <span>{fn} عزیز </span>خوش آمدید 👋 احراز هویت شما تأیید شده است ✅
        </p>
      ),
      cta: <></>,
    },
    profileInfo: {
      text: (
        <p>
          <span>{fn} عزیز </span>خوش آمدید 👋 لطفاً ابتدا در بخش حساب کاربری،
          اطلاعات خود را تکمیل کنید 📋
        </p>
      ),
      cta: (
        <CustomButton
          text="حساب کاربری"
          className="px-5 sm:min-w-40 whitespace-nowrap bg-zi-buttonbg-primary text-zi-text-dark hocus:opacity-85"
          textShadow={true}
          onClick={() => navigate("/profile/information")}
        />
      ),
    },
    buyChallenge: {
      text: (
        <p>
          <span>{fn} عزیز </span>خوش آمدید 👋 برای خرید چالش یا شروع چالش آزمایشی
          اقدام کنید 🛒
        </p>
      ),
      cta: (
        <div className="flex flex-col lg:flex-row items-center gap-2.5 ">
          <CustomButton
            text="شروع چالش جدید"
            className="px-5 min-w-[152px] sm:min-w-40 whitespace-nowrap bg-zi-buttonbg-primary text-zi-text-dark hocus:opacity-85"
            textShadow={true}
            onClick={() => navigate("/purchase")}
          />
          <CustomButton
            onClick={() => navigate("/challenge?next=demo")}
            text="شروع چالش تمرینی"
            className="px-5 min-w-[152px] sm:min-w-40 whitespace-nowrap border border-zi-border-dark bg-transparent text-zi-text-light dark:text-zi-text-dark hocus:ring-inset hocus:ring-1 hocus:ring-zi-border-dark"
          />
        </div>
      ),
    },
    TradeNoFunded: {
      text: (
        <p>
          <span>{fn} عزیز </span>خوش آمدید 👋 همین حالا شروع به معامله در حساب خود
          کنید 💰
        </p>
      ),
      cta: (
        <CustomButton
          text="معامله کنید"
          className="px-5 sm:min-w-40 whitespace-nowrap bg-zi-buttonbg-primary text-zi-text-dark hocus:opacity-85"
          textShadow={true}
          onClick={() => navigate("/trade/account")}
        />
      ),
    },
    kycNeeded: {
      text: (
        <p>
          <span>{fn} عزیز </span>خوش آمدید 👋 مراحل احراز هویت خود را در بخش حساب
          کاربری تکمیل کنید 🪪
        </p>
      ),
      cta: (
        <CustomButton
          text="احراز هویت"
          className="px-5 sm:min-w-40 whitespace-nowrap bg-zi-buttonbg-primary text-zi-text-dark hocus:opacity-85"
          textShadow={true}
          onClick={() => navigate("/profile/kyc")}
        />
      ),
    },
    withdrawCan: {
      text: (
        <p>
          <span>{fn} عزیز </span>خوش آمدید 👋 برای برداشت سود حساب فاندد خود اقدام
          کنید 🪎
        </p>
      ),
      cta: (
        <CustomButton
          text="برداشت سود"
          className="px-5 sm:min-w-40 whitespace-nowrap bg-zi-buttonbg-primary text-zi-text-dark hocus:opacity-85"
          textShadow={true}
          onClick={() => navigate("/Transaction/Withdraw")}
        />
      ),
    },
    TradeFunded: {
      text: (
        <p>
          <span>{fn} عزیز </span>خوش آمدید 👋 همین حالا شروع به معامله در حساب خود
          کنید 💰
        </p>
      ),
      cta: (
        <CustomButton
          text="معامله کنید"
          className="px-5 sm:min-w-40 whitespace-nowrap bg-zi-buttonbg-primary text-zi-text-dark hocus:opacity-85"
          textShadow={true}
          onClick={() => navigate("/trade/account")}
        />
      ),
    },
    default: {
      text: (
        <p>
          <span>{fn} عزیز </span>خوش آمدید 👋
        </p>
      ),
    },
  };

  const data = variants[variant];
  
  if (!data) return null;

  return (
    <section className="w-full h-fit bg-zi-bg2-light dark:bg-gradient-to-br dark:from-amber-950 dark:via-indigo-950 dark:to-cyan-950 rounded-2xl p-5">
      <div className="flex items-center justify-between gap-5">
        <p className="text-sm md:text-base font-medium text-zi-text-light dark:text-zi-text-dark">
          {data.text}
        </p>
        {data && data.cta && <span>{data.cta}</span>}
      </div>
    </section>
  );
}
